<template>
	<div id="mobileApp">
		<div class="headArea" :style="{'background':(scrollTop>70||key.indexOf('seeInfo')>0?'#000':'none')}">
			<div class=" flexBtw mainArea">
				<img class="logoImg" src="../assets/mobile/logo.png" />
				<img class="menuImg" src="../assets/menu.png" @click="menuShow=!menuShow" style="height: 26px;" />
				<div class="navBox" v-if="menuShow">
					<div id="nav" v-if="menuShow" @click.stop="navClick">
						<i class="el-icon-circle-close closeIcon" @click.stop="navClick"></i>
						<router-link :to="(isMobile?'/mobile':'/pc')+'/home'">首页</router-link>
						<router-link :to="(isMobile?'/mobile':'/pc')+'/about'">关于我们</router-link>
						<router-link :to="(isMobile?'/mobile':'/pc')+'/business'">业务布局</router-link>
						<router-link :to="(isMobile?'/mobile':'/pc')+'/cinema'">VR影院</router-link>
						<router-link :to="(isMobile?'/mobile':'/pc')+'/team'">管理团队</router-link>
						<router-link :to="(isMobile?'/mobile':'/pc')+'/see'">橙猩视点</router-link>
						<router-link :to="(isMobile?'/mobile':'/pc')+'/contect'">联系我们</router-link>
					</div>
				</div>
			</div>
		</div>
		<div style="padding-top: -70px;margin-bottom: -30px;">
			<router-view :key="key" />
		</div>
		<div class="footArea">
			<div class="light-1"></div>
			<div class="footBox">
				<img class="a" src="../assets/mobile/logo.png"/>
				<div class="footBoxDec"><img class="footBoxDecImg" src="../assets/phone.png"/> 021-59199956</div>
				<div class="footBoxDec"><img class="footBoxDecImg" src="../assets/local_s.png"/>上海市徐汇区漕溪北路595号A座8013室</div>
				<img class="b" src="../assets/chart.png"/>
				<div class="c">
					<a href="https://beian.miit.gov.cn/">沪ICP备2022023873号-1 Copyright @2022-2026 版权所有 上海橙猩数字娱乐科技有限公司</a><br><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402010121">沪公网安备31010402010121号</a>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		WOW
	} from 'wowjs'
	export default {
		name: 'App',
		data() {
			return {
				menuShow: false,
				scrollTop: 0,
			}
		},
		beforeDestroy() {
			this.scrollTop = 0
			window.scrollTo(0, 0)
		},
		mounted() {
			if (window.innerWidth <= 800) {
				this.menuShow = false
			}
			this.$nextTick(() => {
				window.addEventListener('scroll', this.handleScroll)
				const wow = new WOW({
					boxClass: 'wow',
					animateClass: 'animated',
					offset: 0,
					mobile: true,
					live: true,
				})
				wow.init()
			})
		},
		computed: {
			isMobile() {
				return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			},
			key() {
				return this.$route.path
			}
		},
		methods: {
			handleScroll() {
				this.scrollTop = window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop
			},
			navClick() {
				if (window.innerWidth <= 800 || this.isMobile) {
					this.menuShow = !this.menuShow
				}
			},
		},
	}
</script>
<style lang="less" scoped>
	.footArea{
		background: #000;
		position: relative;
		overflow: hidden;
		padding-top: 30px;
		.footBox{
			position: relative;
			z-index: 2;
			text-align: center;
			.a{
				height: 40px;
				margin-top: 80px;
				margin-bottom: 50px;
			}
			.footBoxDec{
				font-size: 12px;
				padding-left: 20px;
				color: rgba(255, 255, 255, 0.5);
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 10px;
			}
			.footBoxDecImg{
				width: 16px;
				margin-right: 5px;
			}
			.b{
				margin-top: 30px;
				margin-bottom: 80px;
				width: 80px;
			}
			.c{
				border-top: 1px solid rgba(255, 255, 255, 0.3);
				a{
					font-size: 10px;
					color: rgba(255, 255, 255, 0.4);
					line-height: 20px;
					padding-bottom: 20px;
					padding-top: 20px;
					
				}
				
			}
		}
	}
	.flexBtw {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.logoImg{
		height: 24px;
		width: auto;
	}
	.navBox {
		width: 100vw;
		height: 100vh;
		top: 0;
		left: 0;
		position: absolute;
		display: flex;
		z-index: 9999999999;
		background: rgba(0, 0, 0, 0.7);
	}

	#nav {
		background: #fff;
		text-align: left;
		width: 70%;
		margin-left: 30%;
		padding-top: 50px;

		a {
			display: block;
			color: #555;
			font-size: 16px;
			margin-left: 20px;
			line-height: 60px;

			&.router-link-exact-active {
				color: #ff791f;
			}
		}

		.closeIcon {
			color: #333;
			position: absolute;
			right: 20px;
			font-size: 30px;
			top: 20px
		}
	}

	.light-1 {
		position: absolute;
		width: 400px;
		height: 400px;
		border-radius: 50%;
		filter: blur(80px);
		animation: moveAround 10s linear infinite;
		background: rgba(106, 0, 255, 0.2);
		top: 0;
		left: calc(50% - 200px);
		animation-delay: 0s;
		z-index: 1;
	}

	.mainArea {
		width: calc(100% - 300px);
		margin-left: 140px;
		margin-right: 140px;
	}

	.headArea {
		position: fixed;
		padding-top: 20px;
		padding-bottom: 20px;
		width: 100vw !important;
		padding-left: 10px;
		padding-right: 10px;
		top: 0;
		z-index: 9999;
	}

	html {
		scroll-behavior: smooth;
	}

	body * {

		box-sizing: border-box;
		flex-shrink: 0;
		color: #fff;
	}

	* {
		margin: 0;
		padding: 0;
	}

	img {
		vertical-align: top;
		border: 0;
	}

	li {
		list-style: none;
	}

	a {
		color: inherit;
		text-decoration: none;
	}

	a[href] {
		cursor: pointer;
	}

	a:hover {
		text-decoration: none;
		cursor: pointer;
	}



	@media (max-width:1440px) {
		.mainArea {
			width: calc(100% - 100px);
			margin-left: 40px;
			margin-right: 40px;
		}
	}

	@media (max-width:800px) {

		.mainArea {
			width: calc(100% - 20px);
			margin-left: 10px;
			margin-right: 10px;
		}
	}
</style>